import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import Loader from '../../components/loader';
import { servelURL } from '../../config';
import { Helmet } from 'react-helmet';
import DocumentViewer from '../../components/documentViewer';
import backgroundImage from '../../config/logo1.png';
import Input from '../../components/input'
import Button from '../../components/button'

const BlogRead = function (props) {
    const [loading, setLoading] = useState(false);
    const [dataObject, setDataObject] = useState('');
    const [showScrollButton, setShowScrollButton] = useState(false)
    const [disabled, setDisabled] = React.useState(false)
    const [name, setName] = React.useState('')
    const [phone, setPhone] = React.useState('')
    const [description, setDescription] = React.useState('')
    const [nameError, setNameError] = React.useState('')
    const [phoneError, setPhoneError] = React.useState('')
    const [descriptionError, setDescriptionError] = React.useState('')
    const [list, setList] = React.useState([])

    useEffect(() => {
        if (props.location.state) {
            const { blog } = props.location.state;
            setDataObject(blog);
            document.title = `MOCOS | ${blog.title?.toUpperCase()}`;
        } else {
            mount();
        }

        async function mount() {
            try {
                const condition = JSON.stringify({
                    title: props.location.pathname.split('/').pop(),
                });
                const select = JSON.stringify({});
                const schema = 'blog';
                const joinForeignKeys = true;
                const parameters = `schema=${schema}&condition=${condition}&select=${select}&joinForeignKeys=${joinForeignKeys}`;
                let response = await fetch(`${servelURL}/read?${parameters}`, {
                    method: 'GET',
                    mode: 'cors',
                });
                if (response.ok) {
                    response = await response.json();
                    setDataObject(response.message);
                } else {
                    throw new Error('Failed to fetch data');
                }
            } catch (error) {
                new M.Toast({ html: error.message });
            }
            setLoading(false);
        }

        document.title = 'MOCOS | Blog';
        M.AutoInit();

        const handleScroll = () => {
            const shouldShowButton = window.scrollY > 200;
            setShowScrollButton(shouldShowButton);
        };

        window.addEventListener('scroll', handleScroll);

        return function cleanup() {
            window.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line
    }, [props.location.state, props.location.pathname]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    async function submit() {
        try {
            let response = await fetch(`${servelURL}/create`, {
                method: 'POST',
                mode: "cors",
                headers: {
                    "Content-Type": "Application/json"
                },
                body: JSON.stringify({
                    schema: "comment",
                    documentData: {
                        phone: phone,
                        name: name,
                        description: description,
                        blog: props.location.pathname.split('/').pop()
                    }
                })
            })

            response = await response.json()
            if (response.success) {
                setPhone('')
                setName('')
                setDescription('')
                new M.Toast({ html: 'Thank you for your comment concerning this one!!' })
            }
            else new M.Toast({ html: response.message })
        }
        catch (error) {
            setDisabled(true)
            if (error instanceof Error) {
                new M.Toast({ html: error.message })
            }
            else console.log(error)
        }
    }

    const validate = (event) => {
        try {
            event.preventDefault()
            const errors = []

            if ((name !== undefined) && (name.trim() === '')) {
                setDisabled(true)
                setNameError('Please fill this field')
                errors.push('')
            }
            else if ((name !== undefined) && (name.length < 3)) {
                setDisabled(true)
                setNameError('Name should have atleast three digits')
            }

            if ((phone !== undefined) && (phone.trim() === '')) {
                setPhoneError('Please fill this field')
                errors.push('')
                setDisabled(true)
            }
            else if ((phone !== undefined) && (phone.length !== 10)) {
                setPhoneError('Phone should have ten digits')
                setDisabled(true)
                errors.push('')
            }

            if ((description !== undefined) && (description.trim() === '')) {
                setDescriptionError('Please fill this field')
                setDisabled(true)
                errors.push('')
            }

            if (errors.length === 0) {
                submit()
            }
            else setLoading(false)
        }
        catch (error) {
            setDisabled(true)
            if (error instanceof Error) {
                new M.Toast({ html: error.message })
            }
            else console.log(error)
        }
    }


    async function mountComment() {
        try {
            const condition = JSON.stringify({ blog: props.location.pathname.split('/').pop() });
            const select = JSON.stringify({});
            const sort = JSON.stringify({ createdAt: -1 });
            const schema = 'comment';
            const joinForeignKeys = true;
            const parameters = `schema=${schema}&condition=${condition}&sort=${sort}&select=${select}&joinForeignKeys=${joinForeignKeys}`;

            let response = await fetch(`${servelURL}/list-all?${parameters}`, {
                method: 'GET',
                mode: 'cors',
            });

            response = await response.json()
            if (response.success) {
                setList(response.message)
            }
            else setLoading(false)
        }
        catch (error) {
            setDisabled(true)
            if (error instanceof Error) {
                new M.Toast({ html: error.message })
            }
            else console.log(error)
        }
    }

    React.useEffect(function () {
        mountComment()
        // eslint-disable-next-line
    }, [])

    const styles = {
        chip: {
            display: 'inline-block',
            backgroundColor: '#f2f2f2',
            color: '#333',
            padding: '5px 10px',
            borderRadius: '15px',
            marginRight: '5px',
            marginBottom: '5px',
        },
        strongName: {
            fontWeight: 'bold',
        },
    };

    return (
        <main>
            {loading ? <Loader /> : null}
            <div
                className='background-image'
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    opacity: 0.2,
                    zIndex: -1,
                }}
            ></div>
            <Helmet>
                <meta property="og:title" content={`MOCOS | ${dataObject?.title?.replace(/-/g, ' ')?.toUpperCase()}`} />
                <meta property="og:description" content={dataObject?.title?.replace(/-/g, ' ')?.toUpperCase()} />
                <meta property="og:image" content={dataObject?.pic || `mocos.repair.com/blog/blog/${dataObject?.pic}`} />
                <meta property="og:url" content={`https://mocos.repair${props.location.pathname}`} />
                <meta property="og:type" content={dataObject?.title?.replace(/-/g, ' ')?.toUpperCase()} />
            </Helmet>
            <div className='row' style={{ marginTop: '1rem' }}>
                <div className='col s11 '>
                    <a href='/blog/list' className='btn-small red'>
                        <i className='material-icons left'>fast_rewind</i>Go Back
                    </a>
                </div>
            </div>
            <div className='row' style={{ marginTop: '2rem' }}>
                <img src={`${dataObject?.pic}`} alt='pic' width='100%' />
                <div className='col s10 m10 offset-s1 offset-m1'>
                    <h4 className='red-text center'>
                        <i>{dataObject.title?.replace(/-/g, ' ')?.toUpperCase()}</i>
                    </h4>
                    <div>
                        <DocumentViewer document={dataObject?.description} />
                    </div>
                </div>
            </div>
            <h2>{list.len}</h2>
            <div className='row' style={{ marginTop: '4rem' }}>
                <div className='col s10 m4 push-m2 offset-s1'>
                    <h3>Comments {`(${list.length})`} </h3>
                    <div>
                        {list.map((comment, index) => (
                            <div key={index} style={styles.chip}>
                                <span style={styles.strongName}>{comment?.name}</span>: <span>{comment?.description}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col s10 m5 push-m2 offset-s1'>
                    <div className='card hoverable' style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', boxShadow: 'none' }}>
                        <form className='container' onSubmit={validate}>
                            <div className='card-content'>
                                <span className='card-title center'>Leave a comment</span>
                                <div className='row'>
                                    <div className='col s12 m6'>
                                        <Input
                                            name='name'
                                            value={name}
                                            type='text'
                                            label='Full Name'
                                            onChange={(event) => setName(event.target.value, setNameError(''), setDisabled(''))}
                                        />
                                        <span className='helper-text red-text'>{nameError ? nameError : ""}</span>
                                    </div>
                                    <div className='col s12 m6'>
                                        <Input
                                            name='phone'
                                            value={phone}
                                            type='number'
                                            onChange={(event) => setPhone(event.target.value, setDisabled(false), setPhoneError(''))}
                                            label='Phone'
                                        />
                                        <span className='helper-text red-text'>{phoneError ? phoneError : ""}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col s12">
                                        <label>Comment</label>
                                        <textarea
                                            className="textarea"
                                            name='description'
                                            value={description}
                                            onChange={(event) => setDescription(event.target.value, setDisabled(false), setDescriptionError(''))}
                                        >
                                        </textarea>
                                        <span className='helper-text red-text'>{descriptionError ? descriptionError : ""}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='card-action center'>
                                <Button
                                    type='post'
                                    icon='send'
                                    disabled={disabled ? true : false}
                                    className='btn-small red'
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {showScrollButton && (
                <button className='btn-floating btn-large red scroll-button' onClick={scrollToTop}>
                    Top
                </button>
            )}
        </main>
    );
};

export default BlogRead;